<template>
  <div class="demo-tabs-style2">
    <Tabs
      type="card"
      :animated="false"
      name="tab1"
      @on-click="tabsClick"
      v-model="tabValue"
    >
      <TabPane :label="$t('Employee_Overview')"  :index="1" tab="tab1" name="EmployeeList"
        ><EmployeeList ref="EmployeeList"></EmployeeList></TabPane
      ><!-- 员工一览 -->
      <TabPane
        :label="$t('Performance_Priorities')"
        tab="tab1"
        :index="2"
        name="PerformanceFocus"
        ><PerformanceFocus ref="PerformanceFocus"></PerformanceFocus></TabPane
      ><!-- 绩效重点 -->
      <!-- v-if="roleList.includes('NSrNiCgA') || roleList.includes('pHUYkDnC')"  -->
      <TabPane :label="$t('STI_Self')" v-if="roleList.includes('NSrNiCgA') || roleList.includes('pHUYkDnC')" :index="3" tab="tab1"  name="STIPersonalGoals"
        ><STIPersonalGoals ref="STIPersonalGoals"></STIPersonalGoals></TabPane
      ><!-- STI个人目标 -->
      <TabPane
        :label="$t('Behavioural_Expectations')"
        :index="4"
        tab="tab1"
        name="BehaviorExpectation"
        ><BehaviorExpectation
          ref="BehaviorExpectation"
        ></BehaviorExpectation></TabPane
      ><!-- 行为期望 -->
      <TabPane
        :label="$t('Development_Plans')"
        tab="tab1"
        :index="5"
        name="PersonalDevelopmentPlan"
        ><PersonalDevelopmentPlan
          ref="PersonalDevelopmentPlan"
        ></PersonalDevelopmentPlan></TabPane
      ><!-- 个人发展计划 -->
      <TabPane
        :label="$t('Performance_Appraisal')"
        tab="tab1"
        :index="6"
        name="PerformanceEvaluation"
        ><PerformanceEvaluation
          ref="PerformanceEvaluation"
        ></PerformanceEvaluation></TabPane
      ><!-- 绩效评估 -->
      <!-- <TabPane label="潜能评估" tab="tab1"><PotentialAssessment></PotentialAssessment></TabPane> -->
      <!-- <TabPane :label="$t('Talent Tag')" tab="tab1" name="CapabilityAssessment"
        ><CapabilityAssessment
          ref="CapabilityAssessment"
        ></CapabilityAssessment></TabPane -->
      <!-- 人才标签 -->
      <TabPane
        :label="$t('Apply_Performance_Improvement_Plan')"
        tab="tab1"
        :index="7"
        name="PerformanceCoaching"
        ><PerformanceCoaching
          ref="PerformanceCoaching"
        ></PerformanceCoaching></TabPane
      ><!-- 绩效改进 -->
    </Tabs>
    <Spin size="large" fix v-if="spinShow"></Spin>
  </div>
</template>

<script>
import axios from 'axios'
import PerformanceFocus from "./components/PerformanceFocus.vue";
import EmployeeList from "./components/EmployeeList.vue";
import STIPersonalGoals from "./components/STIPersonalGoals.vue";
import BehaviorExpectation from "./components/BehaviorExpectation.vue";
import PersonalDevelopmentPlan from "./components/PersonalDevelopmentPlan.vue";
import PerformanceEvaluation from "./components/PerformanceEvaluation.vue";
import PotentialAssessment from "./components/PotentialAssessment.vue";
import CapabilityAssessment from "./components/CapabilityAssessment.vue";
import PerformanceCoaching from "./components/PerformanceCoaching.vue";
export default {
  components: {
    PerformanceFocus,
    EmployeeList,
    STIPersonalGoals,
    BehaviorExpectation,
    PersonalDevelopmentPlan,
    PerformanceEvaluation,
    PotentialAssessment,
    CapabilityAssessment,
    PerformanceCoaching
  },
  data() {
    return {
      tabValue: "EmployeeList",
      roleList:[],
      spinShow:false,
      nameList: [
        "PerformanceFocus",
        "EmployeeList",
        "STIPersonalGoals",
        "BehaviorExpectation",
        "PersonalDevelopmentPlan",
        "PerformanceEvaluation",
        "PotentialAssessment",
        "CapabilityAssessment",
        "PerformanceCoaching"
      ]
    };
  },
  created(){
    this.getRoleList();
  },
  mounted() {
    if (this.$route.query.name) {
      this.tabValue = this.$route.query.name;
      this.$refs[`${this.$route.query.name}`].getData();
      this.$refs[`${this.$route.query.name}`].getListData();
    }
  },
  methods: {
    getRoleList(){
       this.spinShow=true
       axios.post('/achReport/searchUserRoleList',{}).then((res) => {
        this.roleList = res.data
        this.spinShow = false;
        })
    },
    tabsClick(val) {
      console.log(val)
      if (val == "PerformanceEvaluation") {
        this.$refs.PerformanceEvaluation.tabName = "PerformanceEvaluation";
      } else if (val == "CapabilityAssessment") {
        this.$refs.CapabilityAssessment.tabName = "CapabilityAssessment";
        // this.$refs.CapabilityAssessment.getData()
      }
      this.$refs[`${val}`].getData();
      this.$refs[`${val}`].getListData();
      // 清空其他页面数据
      array.forEach(item => {
        if (item != val) {
          this.$refs[`${item}`].data = [];
        }
      });
    }
  }
};
</script>

<style>
.demo-tabs-style2 > .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab {
  border-radius: 0;
  background: #459846;
  color: #ffffff;
}
.demo-tabs-style2
  > .ivu-tabs.ivu-tabs-card
  > .ivu-tabs-bar
  .ivu-tabs-tab-active {
  /* border-top: 1px solid #ffffff; */
  background: #ffffff;
  border-top: 1px solid #459846 !important;
  border-left: 1px solid #459846 !important;
  border-right: 1px solid #459846 !important;
  color: #333333;
}
.demo-tabs-style2
  > .ivu-tabs.ivu-tabs-card
  > .ivu-tabs-bar
  .ivu-tabs-tab-active:before {
  /* content: '';
        display: block;
        width: 100%;
        height: 1px;
        background: #ffffff;
        position: absolute;
        top: 0;
        left: 0;
        color: #459846; */
}
/* .card-tabs-search >>>.ivu-tabs.ivu-tabs-card {
    border-color:#8CD29B;
  }
 
  .card-tabs-search >>>.ivu-tabs.ivu-tabs-card >.ivu-tabs-bar .ivu-tabs-tab-active{
    background:#8CD29B;
    color: #f5f7f9;
    height:52px;
    border-color:#8CD29B;
  }
  .card-tabs-search >>>.ivu-tabs.ivu-tabs-card >.ivu-tabs-bar .ivu-tabs-tab-focused{
      border-color:#8CD29B;
  }
  .ivu-tabs-nav-container:focus .ivu-tabs-tab-focused {
      border-color:#8CD29B;
  } */
</style>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/PerformanceReport.vue